import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {CdkTableModule} from '@angular/cdk/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatDialogModule} from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';

import {ListViewComponent} from './list-view.component';
import {TranslateHelperModule} from '../translate-helper.module';
import {DeleteConfirmDialogModule} from '../delete-confirm-dialog/delete-confirm-dialog.module';
import {DisplayedColumnsDialogComponent} from './displayed-columns-dialog/displayed-columns-dialog.component';
import {TableFieldsDialogModule} from '../table-fields-dialog/table-fields-dialog.module';
import {GoogleMapsModalComponent} from './google-maps-modal/google-maps-modal.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {SharedModule} from '../shared.module';
import {KeyboardShortcutsModule} from 'ng-keyboard-shortcuts';
import {FilterChipsModule} from '../filter-chips-pipe/filter-chips.module';

@NgModule({
  declarations: [
    ListViewComponent,
    DisplayedColumnsDialogComponent,
    GoogleMapsModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    RouterModule,
    TranslateHelperModule,
    DeleteConfirmDialogModule,
    TableFieldsDialogModule,

    MatExpansionModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    CdkTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    DragDropModule,
    MatDialogModule,
    MatListModule,
    MatMenuModule,
    GoogleMapsModule,
    KeyboardShortcutsModule,
    SharedModule,
    FilterChipsModule,
  ],
  exports: [
    ListViewComponent,
  ],
})
export class ListViewModule {
}

